import React from 'react';

interface Props {
	children?: string;
}

const FirstUpper: React.FC<Props> = ({ children }) => {
	if (!children) {
		return null;
	}
	return <>{firstUpperString(children)}</>;
};

export default FirstUpper;

export const firstUpperString = (text: string): string => {
	return text.charAt(0).toUpperCase() + text.slice(1);
};
